function formatMoney(cents, format = "${{amount}}") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const value = (parseInt(cents, 10) / 100).toFixed(2);
    return format.replace("{{amount}}", value);
}

function initProductSection(section) {
    if (!section) return;

    let product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;
    const pageHandle = product.handle;

    if (Shopify.theme?.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /** Swiper **/

    section.querySelectorAll('.productVisualWrap').forEach(wrap => {
        if (typeof Swiper !== "undefined") {
            new Swiper(wrap.querySelector(".productVisualSwiper"), {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                autoHeight: true,
                pagination: {
                    el: wrap.querySelector(".swiper-pagination"),
                    clickable: true,
                },
            });
        }
    })

    /** Tier selection (multi-pack products) **/
    section.querySelectorAll('.tierCardInput').forEach(input => {
        input.addEventListener('change', () => {
            const card = input.closest('.tierCard');
            if (!card) return;
            section.querySelectorAll('.tierCard').forEach(c => c.classList.remove('checked'));
            card.classList.add('checked');
            const json = card.querySelector('.tierProductJSON');
            if (!json) return;
            try {
                product = JSON.parse(json.textContent);
            } catch (e) {
                return;
            }
            activeVariant = product.variants[0];
            rebuildSellingPlans();
            updateProduct();
        });
    });

    // Show/hide the Subscribe & Save option based on whether the selected
    // tier actually has subscription plans. Only tiers with a plan (today just
    // the 1-case) show it; others hide it and clear any subscribe selection.
    function rebuildSellingPlans() {
        const subOption = section.querySelector('.productFormSellingOption.sub');
        const planSelect = section.querySelector('.productFormSellingOptionPlan');
        const allocations = (activeVariant && activeVariant.selling_plan_allocations) || [];
        if (!subOption) return;
        if (allocations.length) {
            subOption.style.display = '';
            if (planSelect) {
                planSelect.innerHTML = '';
                allocations.forEach((a, i) => {
                    const opt = document.createElement('option');
                    opt.value = a.selling_plan.id;
                    opt.textContent = a.selling_plan.name + (i === 0 ? ' (Recommended)' : '');
                    planSelect.appendChild(opt);
                });
            }
        } else {
            subOption.style.display = 'none';
            const subInput = subOption.querySelector('.productFormSellingOptionHeaderInput');
            if (subInput) subInput.checked = false;
            subOption.classList.remove('active');
        }
    }

    /** Option change **/
    section.querySelectorAll("input, select").forEach(el => {
        if (el.classList.contains('tierCardInput')) return;
        el.addEventListener("change", () => {
            // Subscribe & Save is an opt-in checkbox: checked = subscription, unchecked = one-time.
            if (el.classList.contains('productFormSellingOptionHeaderInput')) {
                const opt = el.closest('.productFormSellingOption');
                if (opt) {
                    if (el.checked) opt.classList.add('active');
                    else opt.classList.remove('active');
                }
            }
            updateProduct();
        });
    });

    function isSubscription() {
        return !!section.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    function updateProduct() {
        const hasTiers = !!section.querySelector('.tierCardInput');
        if (hasTiers || product.variants.length === 1) {
            if (!activeVariant) activeVariant = product.variants[0];
        } else {
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem`).forEach(group => {
                const selected = group.querySelector(`input:checked`);
                if (selected) options.push(selected.value);
            });
            activeVariant = product.variants.find(v => JSON.stringify(v.options) === JSON.stringify(options));
        }

        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        // Simple price line (non-tier products like the Variety Pack). Tiered
        // products show price in the tier cards; the subscribe row price is
        // server-rendered, so nothing else needs live price updates here.
        const simpleReal = section.querySelector('.productSimplePriceReal');
        const simpleCompare = section.querySelector('.productSimplePriceCompare');
        if (simpleReal) simpleReal.textContent = formatMoney(activeVariant.price);
        if (simpleCompare) simpleCompare.textContent = (activeVariant.compare_at_price && activeVariant.compare_at_price > activeVariant.price) ? formatMoney(activeVariant.compare_at_price) : '';

        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Sold Out";
        }

        if (product.handle === pageHandle) {
            const url = new URL(window.location.href);
            url.searchParams.set("variant", activeVariant.id);
            window.history.replaceState({}, "", url);
        }
    }

    /** Quantity buttons **/
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", () => {
        if (quantity > 1) {
            quantity--;
            section.querySelector(".productQuantityControlsValue").textContent = quantity;
            updateProduct();
        }
    });

    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", () => {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    /** Add to cart **/
    section.querySelector(".productATC")?.addEventListener("click", async () => {
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity,
                id: activeVariant.id
            }]
        };

        if (isSubscription()) {
            const plan = section.querySelector('.productFormSellingOptionPlan');
            if (plan) formData.items[0].selling_plan = parseInt(plan.value);
        }

        await addProduct(formData);

        section.querySelector(".productATC").classList.remove("loading");

        await openCart()

    });

    const toggleBtn = section.querySelector('.productMoreInfoButton');
    const wrapper = section.querySelector('.productNutritionWrapper');

    if (toggleBtn && wrapper) {
        toggleBtn.addEventListener('click', () => {
            const isOpen = wrapper.classList.contains('open');

            if (isOpen) {
                wrapper.style.height = wrapper.scrollHeight + 'px';
                requestAnimationFrame(() => {
                    wrapper.style.height = '0px';
                    wrapper.classList.remove('open');
                    toggleBtn.classList.remove('open');
                });
            } else {
                wrapper.style.height = wrapper.scrollHeight + 'px';
                wrapper.classList.add('open');
                toggleBtn.classList.add('open');
                setTimeout(() => {
                    wrapper.style.height = 'auto';
                }, 400);
            }
        });
    }

    rebuildSellingPlans();
    updateProduct();
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.product').forEach(initProductSection);
});
